var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPoloniex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5278_18456)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5278_18456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6523 12.484V22.3703L30.0923 17.4307L21.5322 12.4625L30.1138 7.5444L38.681 2.59766L38.6594 12.484H38.6523Z",
    fill: "#042B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.511 22.3473V32.2336L12.951 27.294L4.38379 22.3186L12.9438 17.4005L21.5038 12.4609V22.3473H21.511Z",
    fill: "#154556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38379 12.441V2.55469L12.9438 7.49427L21.5038 12.4338L12.9438 17.4021L4.38379 22.3202V12.441Z",
    fill: "#41D9BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3623 32.2066L4.38381 22.3203L12.9438 27.2886L21.5039 32.2281L12.9438 37.1677L4.3623 42.093V32.2066Z",
    fill: "#042B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0923 17.4292L21.5322 12.4609V32.2264L30.0707 37.1947L38.6308 42.1343V32.2479L38.6523 22.3616L30.0923 17.422V17.4292Z",
    fill: "#41D9BF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5278_18456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.35,
    height: 43.35,
    fill: "white",
    transform: "translate(0.75 0.75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5278_18456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.319,
    height: 39.5812,
    fill: "white",
    transform: "translate(4.3623 2.55469)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoloniex);
export default __webpack_public_path__ + "static/media/poloniex.716625fa808bdf335ad52dfb089dbf6e.svg";
export { ForwardRef as ReactComponent };